'use client'

import { defaultTopNavV6Props } from './TopNavV6.defaults'
import { TopNavV6AccountPanel } from './TopNavV6AccountPanel/TopNavV6AccountPanel'
import { TopNavV6Provider } from './TopNavV6Context'
import { TopNavV6Desktop } from './TopNavV6Desktop/TopNavV6Desktop'
import { TopNavV6DesktopSubNav } from './TopNavV6Desktop/TopNavV6DesktopSubNav'
import { TopNavV6Mobile } from './TopNavV6Mobile/TopNavV6Mobile'
import type { TopNavV6Props } from './TopNavV6Props'

const TopNavV6Content = (props: TopNavV6Props) => {
  const { navItems } = props

  // Find the active nav item with sub-nav items (or first nav item with sub-nav items)
  const activeNavItem = navItems?.find(
    (item) => item.isActive && item.navItems && item.navItems.length > 0
  )
  const subNavItems = activeNavItem?.navItems ?? []

  return (
    <>
      <div className="relative w-full">
        <TopNavV6Mobile {...props} />
        <div className="hidden lg:block">
          <TopNavV6Desktop {...props} />
          {subNavItems.length > 0 && <TopNavV6DesktopSubNav items={subNavItems} />}
        </div>
      </div>
      <TopNavV6AccountPanel />
    </>
  )
}

export const TopNavV6 = (props: TopNavV6Props = defaultTopNavV6Props) => {
  const { account } = props
  return (
    <TopNavV6Provider account={account}>
      <TopNavV6Content {...props} />
    </TopNavV6Provider>
  )
}
